import { createSvgIcon } from '@mui/material';
import React from 'react';

export const SubmissionsPipeline = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="14" viewBox="0 0 17 14" fill="none">
        <path
            d="M5.975 1.66666L7.64166 3.33333H15V11.6667H1.66666L1.67418 11.456L1.67318 10.8334H0.00325L0.00338006 11.2293L0.00651002 4.20573L1.67418 4.18662L1.66666 1.66666H5.975ZM6.66666 0H1.66666C0.75 0 0.00832999 0.75 0.00832999 1.66666C0.00665999 3.61929 0 11.6667 0 11.6667C0 12.5834 0.75 13.3334 1.66666 13.3334H15C15.9167 13.3334 16.6667 12.5834 16.6667 11.6667V3.33333C16.6667 2.41666 15.9167 1.66666 15 1.66666H8.33335L6.66666 0Z"
            fill="currentColor"
        />
        <path
            d="M5.90405 9.57816L7.09737 8.32816H1.66666V10.8282H0V8.32816V6.66147H7.09736L5.90405 5.41147L6.78794 4.57812L9.49015 7.49466L6.78794 10.6103L5.90405 9.57816Z"
            fill="currentColor"
        />
    </svg>,
    'SubmissionsPipeline'
);
